<template>
  <ArticleCard
    ref="article"
    type="answer"
    :article="answerId"
    :liked="liked"
    :answer="answer"
    :loading="loading"
    :adopted="adopted"
    class="p-answer-detail"
    :feed="question"
    :is-mine="isMyQuestion"
    :is-my-question="isMyQuestion"
    :comment-count.sync="commentCount"
    :collected="collected"
    @like="likeAnswer"
    @comment="$refs.comments.open()"
    @more="moreAction"
    @adopt="onAdopt"
    @collect="collect"
  >
    <CommonHeader slot="head">
      <div slot="left" class="head-left">
        <svg class="m-style-svg m-svg-def" @click="goBack">
          <use class="svg" xlink:href="#icon-back" />
        </svg>
        {{ question.subject&&question.subject.slice(0,15) || $t('question.answer.detail') }}
      </div>
      <!-- <span slot="right" class="head-right">
        <svg class="m-style-svg m-svg-def" @click="moreAction">
          <use xlink:href="#icon-more" />
        </svg>
      </span> -->
    </CommonHeader>

    <template slot="main">
      <main class="m-flex-shrink1 m-flex-grow1 m-art m-main">
        <!-- 回答者信息 -->
        <div class="user-info-wrap">
          <Avatar :anonymity="answer.anonymity" :user="user" />
          <div class="user-info">
            <h2 v-if="isMine || !answer.anonymity" class="m-text-cut">
              {{ user.name }}
              <span v-if="answer.anonymity" class="gray">(匿名)</span>
            </h2>
            <h2 v-else class="m-text-cut">{{ $t('profile.anonymity') }}</h2>
            <p class="m-text-cut">
              {{ user.office }} {{ user.office?'-':'' }} {{ user.department }}
            </p>
            <!-- <p v-if="isMine || !answer.anonymity" class="m-text-cut">{{ user.bio || $t('profile.default_bio') }}</p> -->
          </div>
          <template
            v-if="!isMine && !answer.anonymity"
            :class="{ primary: user.follower }"
          >
            <span
              v-if="!user.follower"
              class="actived"
              @click="followUser(true)"
            >
              <svg class="m-style-svg follow-btn">
                <use xlink:href="#icon-plus" />
              </svg>
              {{ $t('follow.name') }}
            </span>
            <span v-else @click="followUser(false)">
              <svg class="m-style-svg follow-btn">
                <use xlink:href="#icon-yes" />
              </svg>
              {{ $t('follow.already') }}
            </span>
          </template>
        </div>
        <div class="m-art-body">
          <p class="m-text-box markdown-body" v-html="formatBody(parseAtmessageBody)" />
          <div
            v-for="attachment in answer.attachments"
            v-if="answer.attachments"
            :key="attachment.id"
            class="m-attach"
          >
            <div class="m-attach__file m-box" @click="downloadFile(attachment)">
              <attachment-type :name="attachment.file.origin_filename" />
              <span class="m-attach__filename">{{ attachment.file.origin_filename }}</span>
            </div>
          </div>
        </div>

        <!-- 点赞组件 -->
        <ArticleLike
          :likers="likes"
          :like-count="likeCount"
          :time="time"
          :view-count="viewsCount"
        />

        <!-- 打赏组件 -->
        <ArticleReward
          v-if="allowReward"
          type="answer"
          :article="answerId"
          :is-mine="isMine"
          v-bind="reward"
          :count="rewardCount"
          :amount="rewardAmount"
          @success="amount => fetchAnswerRewards(amount)"
        />
      </main>

      <!-- 评论列表 -->
      <ArticleComments
        ref="comments"
        type="answer"
        :article="answerId"
        :total.sync="commentCount"
        :fetching="fetchComing"
        @reply="replyComment"
      />
    </template>
  </ArticleCard>
</template>

<script>
  import { mapState } from 'vuex'
  import markdownIt from 'markdown-it'
  import parseAtmessage, { getBodyAsync } from '@/util/parseAt.js'
  import plusImagePlugin from 'markdown-it-plus-image'
  import * as api from '@/api/question/answer'
  import * as userApi from '@/api/user'
  import ArticleCard from '@/page/article/AnswerCard.vue'
  import ArticleLike from '@/page/article/components/ArticleLike'
  import ArticleReward from '@/page/article/components/ArticleReward'
  import AttachmentType from '@/components/common/AttachmentType.vue'
  import ArticleComments from '@/page/article/components/ArticleComments'
  import FileSaver from 'file-saver'
  import wechatShare from '@/util/wechatShare'

  export default {
    name: 'AnswerDetail',
    components: {
      ArticleCard,
      ArticleLike,
      ArticleReward,
      AttachmentType,
      ArticleComments,
    },
    data () {
      return {
        loading: false,
        fetching: false,

        answer: {},
        rewardCount: 0,
        rewardAmount: 0,
        rewardList: [],

        fetchComing: false,
        fetchFollow: false,
        parseAtmessageBody: '',
      }
    },
    computed: {
      ...mapState(['CURRENTUSER']),
      allowReward () {
        return this.$store.state.CONFIG.site.reward.status
      },
      reward () {
        return {
          count: this.rewardCount,
          amount: this.rewardAmount,
          list: this.rewardList,
        }
      },
      questionId () {
        return Number(this.$route.params.questionId)
      },
      answerId () {
        return Number(this.$route.params.answerId)
      },
      question () {
        return this.answer.question || {}
      },
      user () {
        return this.answer.user || {}
      },
      time () {
        return this.answer.created_at || ''
      },
      liked: {
        get () {
          return !!this.answer && !!this.answer.liked
        },
        set (val) {
          this.answer.liked = val
        },
      },
      likes () {
        return this.answer.likes || []
      },
      collected: {
        get () {
          return this.answer.collected
        },
        set (val) {
          this.answer.collected = val
        },
      },
      likeCount: {
        get () {
          return this.answer.likes_count || 0
        },
        set (val) {
          this.answer.likes_count = ~~val
        },
      },
      viewsCount () {
        return this.answer.views_count || 0
      },
      commentCount: {
        get () {
          return this.answer.comments_count || 0
        },
        set (val) {
          this.answer.comments_count += val
        },
      },
      content () {
        const body = this.answer.body || ''
        return parseAtmessage(body)
      },
      isMine () {
        return this.user.id === this.CURRENTUSER.id
      },
      isMyQuestion () {
        return this.question.user_id === this.CURRENTUSER.id
      },
      isWechat () {
        return this.$store.state.BROWSER.isWechat
      },
      adopted () {
        return !!this.answer.adoption
      },
    },
    mounted () {
      this.fetchAnswer()
    },
    methods: {
      downloadFile ({ id, file }) {
        // window.open(`${this.$http.defaults.baseURL}/files/${file.id}`)
        if (/.(png|jpg|jpeg|pdf)$/.test(file.filename)) {
          return window.open(`${this.$http.defaults.baseURL}/files/${id}`)
        }
        this.$http.get(`/files/${id}?json=1`, {
          validateStatus: s => s === 200,
        }).then(res => {
          FileSaver.saveAs(res.data.url, file.origin_filename)
        })
      },
      getAvatar (avatar) {
        avatar = avatar || {}
        return avatar.url || null
      },
      getParseAtMessageBody () {
        getBodyAsync(this.answer.body || '').then(res => {
          this.parseAtmessageBody = res
        }, () => {
          this.parseAtmessageBody = ''
        })
      },
      formatBody (body) {
        return markdownIt({
          html: true,
        })
          .use(plusImagePlugin, `${this.$http.defaults.baseURL}/files/`)
          .render(body)
      },
      likeAnswer () {
        if (this.fetching) return
        this.fetching = true
        if (this.liked) {
          api
            .unlike(this.answerId)
            .then(() => {
              this.liked = false
              this.likeCount -= 1
              this.answer.likes = this.answer.likes.filter(like => {
                return like.user_id !== this.CURRENTUSER.id
              })
            })
            .finally(() => {
              this.fetching = false
            })
        } else {
          api
            .like(this.answerId)
            .then(() => {
              this.liked = true
              this.likeCount += 1
              if (this.answer.likes.length < 5) {
                this.answer.likes.push({
                  user: this.CURRENTUSER,
                  id: +new Date(),
                  user_id: this.CURRENTUSER.id,
                })
              }
            })
            .finally(() => {
              this.fetching = false
            })
        }
      },
      moreAction () {
        const actions = []
        actions.push({
          text: this.$t('share'),
          method: () => {
            this.$Message.info(this.$t('article.share_brownser'))
          },
        })
        if (!this.isMine) {
          actions.push({
            text: this.$t('report.name'),
            method: () => {
              this.$bus.$emit('report', {
                type: 'answer',
                payload: this.answerId,
                username: this.answer.anonymity ? this.$t('profile.anonymity') : this.answer.user.name,
                reference: this.answer.body,
              })
            },
          })
        } else {
          // deleteAnswerComment
          actions.push({
            text: this.$t('delete.name'),
            method: () => {
              setTimeout(() => {
                const actions = [
                  {
                    text: this.$t('delete.name'),
                    style: { color: '#f4504d' },
                    method: () => {
                      api.deleteAnswer(this.answerId)
                        .then(() => {
                          this.$Message.success(this.$t('delete.success'))
                          this.goBack()
                        })
                    },
                  },
                ]
                this.$bus.$emit('actionSheet', actions, this.$t('cancel'), this.$t('delete.confirm'))
              }, 200)
            },
          })
        }
        this.$bus.$emit('actionSheet', actions)
      },
      collect () {
        if (!this.collected) {
          api.collect(this.answerId).then(() => {
            this.collected = true
            this.$Message.success(this.$t('collect.success'))
          })
        } else {
          api.unCollect(this.answerId).then(() => {
            this.collected = false
            this.$Message.success(this.$t('collect.cancel'))
          })
        }
      },
      fetchAnswerRewards (inc = 0) {
        if (inc) {
          this.rewardCount += 1
          this.rewardAmount += inc
        } else {
          const { rewarder_count: count = 0, rewarder_amount: amount = 0 } = this.answer
          this.rewardAmount = Number(amount)
          this.rewardCount = Number(count)
        }
        api.getAnswerRewards(this.answerId, { limit: 10 })
          .then(({ data }) => {
            this.rewardList = data
          })
      },
      fetchAnswer () {
        if (this.loading) return
        this.loading = true

        api.getAnswer(this.answerId).then(({ data }) => {
          this.answer = data
          this.getParseAtMessageBody()
          const { rewarders = [] } = data
          document.title = this.question.subject
          this.reward.count = data.rewarder_count
          this.reward.amount = data.rewards_amount
          this.rewardList = data.rewarders
          this.fetchAnswerComments()
          this.loading = false
          // this.rewardAmount = rewarders.reduce((old, cur) => old + cur.amount, 0)
          this.rewardAmount = data.rewards_amount || rewarders.reduce((old, cur) => old + cur.amount, 0)
          this.rewardCount = data.rewarder_count || rewarders.length
          const shareUrl =
            window.location.origin +
            process.env.BASE_URL.substr(0, process.env.BASE_URL.length - 1) +
            this.$route.fullPath
          const signUrl =
            this.$store.state.BROWSER.OS === 'IOS' ? window.initUrl : shareUrl

          this.$store.state.BROWSER.isWechat && wechatShare(signUrl, {
            title: data.question.subject || '回答详情',
            desc: data.text_body,
            link: shareUrl
          })
        })
      },
      fetchAnswerComments () {
        this.$refs.comments.fetch()
      },
      onAdopt () {
        if (this.answer.adoption) {
          api.deleteAdoptionAnswer(this.questionId, this.answerId)
            .then(() => {
              this.answer.adoption = 0
              this.$Message.success(this.$t('question.answer.cancel_adoption_success'))
            })
          return
        }
        api.adoptionAnswer(this.questionId, this.answerId)
          .then(() => {
            this.answer.adoption = 1
            this.$Message.success(this.$t('question.answer.adoption_success'))
          })
      },
      replyComment (comment, base) {
        const actions = []
        // 是否是自己的评论
        if (comment.user_id === this.CURRENTUSER.id) {
          actions.push({
            text: this.$t('comment.delete.name'),
            method: () => this.$refs.comments.delete((base && base.del) || comment.id),
          })
        } else {
          actions.push({
            text: this.$t('reply.name'),
            method: () => this.$refs.comments.open(comment),
          })
          actions.push({
            text: this.$t('report.name'),
            method: () => {
              this.$bus.$emit('report', {
                type: 'postComment',
                payload: comment.id,
                username: comment.user.name,
                reference: comment.body,
              })
            },
          })
        }
        this.$bus.$emit('actionSheet', actions)
      },
      followUser (status) {
        if (this.fetchFollow) return
        this.fetchFollow = true
        status = status ? 'unFollow' : 'follow'

        userApi.followUserByStatus({ id: this.user.id, status }).then(() => {
          this.fetchFollow = false
          this.user.follower = !this.user.follower
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.p-answer-detail {
  .m-attach {
    width: 100%;
    &__file {
      flex-basis: 100%;
      margin-top: 20px;
    }
    &__filename {
      display: inline-block;
      font-size: 28px;
      margin-left: 20px;
      flex-grow: 1;
      word-break: break-all;
    }
  }
  .user-info-wrap {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 20px;
    height: 120px;
    border-bottom: 1px solid #ededed; /* no */

    .user-info {
      flex: auto;
      margin-left: 20px;
      font-size: 26px;
      overflow: hidden;

      .gray {
        color: @text-color3;
      }
      > p {
        color: @paracolor;
      }

      + span {
        flex: none;
        border: 1px solid @text-color3; /* no */
        color: @text-color3;
        border-radius: 10px;
        font-size: 28px;
        padding: 4px 10px;
        display: inline-block;
        width: 5em;
        text-align: center;

        .follow-btn {
          color: @text-color3;
          width: 20px;
          height: 20px;
          vertical-align: baseline;
        }

        &.actived {
          color: #fff;
          background-color: @primary;
          border-color: transparent;
          .follow-btn {
            color: #fff;
          }
        }
      }
    }
  }
}
.head-left {
  font-size: 32px;
}
.head-right {
  color: @primary;
}
</style>
